import { Preferences } from '@capacitor/preferences';

/** Typed key–value storage backed by Capacitor Preferences (native) or localStorage (web). */

export async function storageGet(key) {
  const { value } = await Preferences.get({ key });
  if (value === null) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

export async function storageSet(key, value) {
  await Preferences.set({ key, value: JSON.stringify(value) });
}

export async function storageRemove(key) {
  await Preferences.remove({ key });
}
